<div *ngIf="loading">
  <div *ngFor="let number of [1, 4, 3, 4]" class="app-slider-wrapper">
    <app-slider [placeholder]="true"></app-slider>
  </div>
</div>

<div class="slider-wrapper">
  <app-mandatory-training *ngIf="loggedUser && isManagementHubActive"></app-mandatory-training>
  <active-records-swiper *ngIf="loggedUser && showActiveCheckoutsCarousel && activeRecordOrder === 0"></active-records-swiper>
  <app-slider-classic
    *ngIf="firstCollection$ | async as firstCollection"
    [collection]="firstCollection"
    [preview]="true"></app-slider-classic>
  <active-records-swiper *ngIf="loggedUser && showActiveCheckoutsCarousel && (activeRecordOrder === 1)"></active-records-swiper>
</div>

<app-slider-user-actions
  *ngIf="showSliderUserActions && (userActions.length || canCreateUserGroups)"
  [userActions]="userActions"></app-slider-user-actions>

<div *ngFor="let collection of restCollections$ | async; let i = index" class="slider-wrapper">
  <ng-container *ngIf="filter.type === 'TAGS'">
    <app-tag-cloud [filter]="filter" [limit]="25" *ngIf="i === tagCloudPosition"></app-tag-cloud>
  </ng-container>

  <app-slider-classic [collection]="collection" [preview]="true"></app-slider-classic>

  <active-records-swiper *ngIf="loggedUser && showActiveCheckoutsCarousel && (activeRecordOrder === i + 2)"></active-records-swiper>
</div>

<active-records-swiper *ngIf="loggedUser && showActiveCheckoutsCarousel && (activeRecordOrder > (collectionsLength$ | async) && activeRecordOrder !== 1)"></active-records-swiper>
